import { c as _c } from "react/compiler-runtime";
import type { ChangeEvent } from "react";
import { parsePositiveWholeNumberInput } from "../utils/positiveWholeNumberInput";
import VotingSettingBox, { getVotingSettingInputClasses } from "./VotingSettingBox";
export default function CreateWaveVotingThreshold(t0) {
  const $ = _c(41);
  const {
    threshold,
    error,
    setThreshold
  } = t0;
  let t1;
  if ($[0] !== setThreshold) {
    t1 = e => {
      setThreshold(parsePositiveWholeNumberInput(e.target.value));
    };
    $[0] = setThreshold;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const onThresholdChange = t1;
  let T0;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[2] !== error || $[3] !== onThresholdChange || $[4] !== threshold) {
    const hasThreshold = threshold !== null && Number.isInteger(threshold) && threshold > 0;
    T0 = VotingSettingBox;
    t9 = "approval-threshold-error";
    t10 = "Enter an approval threshold greater than 0.";
    t11 = error;
    t12 = "approval-threshold-help";
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
      t13 = <>A drop is approved when its vote score reaches this number. Example: 50 means the drop needs a score of 50 to win.</>;
      $[20] = t13;
    } else {
      t13 = $[20];
    }
    t14 = "approval-threshold";
    t15 = "Approval threshold";
    t2 = "text";
    t3 = "numeric";
    t4 = "off";
    t5 = hasThreshold ? threshold.toString() : "";
    t6 = onThresholdChange;
    t7 = "approval-threshold";
    t8 = getVotingSettingInputClasses({
      hasError: error,
      hasValue: hasThreshold
    });
    $[2] = error;
    $[3] = onThresholdChange;
    $[4] = threshold;
    $[5] = T0;
    $[6] = t10;
    $[7] = t11;
    $[8] = t12;
    $[9] = t13;
    $[10] = t14;
    $[11] = t15;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    T0 = $[5];
    t10 = $[6];
    t11 = $[7];
    t12 = $[8];
    t13 = $[9];
    t14 = $[10];
    t15 = $[11];
    t2 = $[12];
    t3 = $[13];
    t4 = $[14];
    t5 = $[15];
    t6 = $[16];
    t7 = $[17];
    t8 = $[18];
    t9 = $[19];
  }
  const t16 = error ? "approval-threshold-error approval-threshold-help" : "approval-threshold-help";
  let t17;
  if ($[21] !== error || $[22] !== t16 || $[23] !== t2 || $[24] !== t3 || $[25] !== t4 || $[26] !== t5 || $[27] !== t6 || $[28] !== t7 || $[29] !== t8) {
    t17 = <input type={t2} inputMode={t3} autoComplete={t4} value={t5} onChange={t6} id={t7} className={t8} aria-invalid={error} aria-describedby={t16} />;
    $[21] = error;
    $[22] = t16;
    $[23] = t2;
    $[24] = t3;
    $[25] = t4;
    $[26] = t5;
    $[27] = t6;
    $[28] = t7;
    $[29] = t8;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] !== T0 || $[32] !== t10 || $[33] !== t11 || $[34] !== t12 || $[35] !== t13 || $[36] !== t14 || $[37] !== t15 || $[38] !== t17 || $[39] !== t9) {
    t18 = <T0 errorId={t9} errorMessage={t10} hasError={t11} helpId={t12} helpText={t13} inputId={t14} label={t15}>{t17}</T0>;
    $[31] = T0;
    $[32] = t10;
    $[33] = t11;
    $[34] = t12;
    $[35] = t13;
    $[36] = t14;
    $[37] = t15;
    $[38] = t17;
    $[39] = t9;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  return t18;
}